import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';
import { LinkTarget } from '../breadcrumbs.types';

/**
 * @slot - the label of the breadcrumb
 */
@Component({
  tag: 'wb-breadcrumb',
  styleUrl: 'breadcrumb.scss',
  shadow: true,
})
export class BreadcrumbComponent implements ComponentInterface {
  /** Optional URL to direct the user to when the breadcrumb item is activated. */
  @Prop({ reflect: true })
  public href?: string;

  /** Tells the browser where to open the link. */
  @Prop({ reflect: true })
  public target?: LinkTarget;

  /** The rel attribute to use on the link. */
  @Prop({ reflect: true })
  public rel?: string;

  private TagNames = transformTagNames(this, 'wb-breadcrumb', ['wb-icon', 'wb-link', 'wb-breadcrumbs']);

  public render(): JSX.Element {
    const { WbLink, WbIcon } = this.TagNames;

    return (
      <Host class="wb-breadcrumb">
        <WbLink variant="standalone" size="m" href={this.href} rel={this.rel} target={this.target}>
          <slot />
        </WbLink>
        <WbIcon class="icon" name="bds/chevron-right/16" flip-rtl />
      </Host>
    );
  }
}
